const TYPES = ['png', 'jpg', 'jpeg', 'avif', 'webp', 'heif', 'heic', 'heif-sequence', 'heic-sequence'];

export { TYPES };
